import { render, staticRenderFns } from "./CajaPaleta.vue?vue&type=template&id=0871e69a&scoped=true&"
import script from "./CajaPaleta.vue?vue&type=script&lang=js&"
export * from "./CajaPaleta.vue?vue&type=script&lang=js&"
import style0 from "./CajaPaleta.vue?vue&type=style&index=0&id=0871e69a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871e69a",
  null
  
)

export default component.exports